import infiniteScrollDirective from "./InfiniteScroll";
import authHandler from "./auth";
import hoverHander from "./hover";
import LazyDirective from "./lazy";
import Throttle from "./throttle";

const directives = [
  infiniteScrollDirective,
  authHandler,
  hoverHander,
  LazyDirective,
  Throttle,
];

const BrcDirectivesPlugin = {
  install(app: any) {
    directives.forEach((drt: any) => {
      drt.install(app);
    });
  },
};
export default BrcDirectivesPlugin
